"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchDoiPages = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchDoiPages = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.DoiPagesActionTypes.LOAD_DOI_PAGES,
  requestStatusSelector: _selectors.getFetchDoiPagesRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_ONCE,
  requestActions: _actions.FetchDoiPages
}));
exports.fetchDoiPages = fetchDoiPages;
var updateDoiPage = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.DoiPagesActionTypes.UPDATE_DOI_PAGE,
  requestStatusSelector: _selectors.getUpdateDoiPageRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateDoiPage
}));

var _default = (0, _reduxObservable.combineEpics)(fetchDoiPages, updateDoiPage);

exports.default = _default;